import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DetailsItem,
    TableBodyRow,
    TbodyRowWrapper,
    TbodyCellFirst,
    PositionWrapper,
    TbodyCellSummary,
    TbodyCell,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RaceDetails/RowItem/RowItem.style';
import { formatAsOrdinalSuffix } from 'src_common/utils/format/formatData';
import { RacingFormDetailsModelType } from 'src_common/common/websocket2/modelsApi/Event';

interface RowItemPropsType {
    detail: RacingFormDetailsModelType;
}

const isValidDetail = (detail?: string | null): detail is string => {
    return detail !== undefined && detail !== null && detail.trim() !== '';
};

export const RowItem = observer('RowItem', ({ detail }: RowItemPropsType): JSX.Element => {
    const { date, distance, startingPrice, finishPosition, runnersCount, courseName, handicap } = detail;

    const formattedPosition = typeof finishPosition === 'number' ? formatAsOrdinalSuffix(finishPosition) : 'N/A';

    return (
        <TableBodyRow>
            <TbodyCellFirst>
                <PositionWrapper>{formattedPosition}</PositionWrapper>
                {runnersCount ?? 'N/A'}
            </TbodyCellFirst>

            <TbodyRowWrapper>
                <TbodyCell>{courseName ?? 'Unknown'}</TbodyCell>
                <TbodyCellSummary>
                    <DetailsItem title='Date'>{isValidDetail(date) ? date : 'N/A'}</DetailsItem>
                    <DetailsItem title='Distance'>{isValidDetail(distance) ? distance : 'N/A'}</DetailsItem>
                    {handicap === true && <DetailsItem title='Handicap'>Handicap</DetailsItem>}
                    <DetailsItem title='SP'>{isValidDetail(startingPrice) ? `${startingPrice} SP` : 'N/A'}</DetailsItem>
                </TbodyCellSummary>
            </TbodyRowWrapper>
        </TableBodyRow>
    );
});
